module.exports = __webpack_public_path__ + "static/img/hafen.040ef38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WED_Hafen/hafen.jpg
// module id = 7Sn+
// module chunks = 0